import { useCallback, useState } from 'react';

type ConnectionsFeedbackOptions = {
	contentId: string;
	onShareFeedback?: () => void;
};

type FeedbackVisit = {
	contentId: string;
	isFeedbackOpen: boolean;
};

type ConnectionsFeedback = {
	isFeedbackOpen: boolean;
	openFeedback: () => void;
	closeFeedback: () => void;
};

export const useConnectionsFeedback = ({
	contentId,
	onShareFeedback,
}: ConnectionsFeedbackOptions): ConnectionsFeedback => {
	const [visit, setVisit] = useState<FeedbackVisit | null>(null);
	if (visit && visit.contentId !== contentId) {
		setVisit(null);
	}
	const openFeedback = useCallback(() => {
		if (onShareFeedback) {
			onShareFeedback();
			return;
		}
		setVisit({ contentId, isFeedbackOpen: true });
	}, [contentId, onShareFeedback]);
	const closeFeedback = useCallback(
		() => setVisit((current) => (current ? { ...current, isFeedbackOpen: false } : null)),
		[],
	);

	return {
		isFeedbackOpen: visit?.contentId === contentId && visit.isFeedbackOpen,
		openFeedback,
		closeFeedback,
	};
};
